const __mainWrapper = ({ isOpen }) => ({
	display: isOpen ? 'block' : 'none',
	zIndex: 1300,
	position: 'fixed',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	backgroundColor: 'rgba(0,0,0,0.5)',
})

const __drawerWrapper = ({ theme, minHeight }) => ({
	position: 'fixed',
	left: 0,
	right: 0,
	bottom: 0,
	minHeight: minHeight || 450,
	backgroundColor: theme.colors.white,
	borderTopLeftRadius: theme.spaces[24],
	borderTopRightRadius: theme.spaces[24],
})

const __handleWrapper = ({ theme }) => ({
	width: theme.spaces[120],
	height: theme.lineHeight,
	backgroundColor: theme.colors.darkGrey6,
	borderRadius: theme.spaces[4],
	margin: '10px auto',
})

const __contentWrapper = () => ({
	margin: '10px 0',
	maxHeight: '72.5vh',
	overflow: 'scroll',
})

const __iconWrapper = ({ theme }) => ({
	position: 'absolute',
	background: theme.colors.black,
	opacity: '0.9',
	color: '#GGGGG',
	borderRadius: '50%',
	marginBottom: theme.spaces[16],
	zIndex: '302',
	top: -60,
	left: '45%',
	padding: '10px 11px',
})

export {
	__mainWrapper,
	__drawerWrapper,
	__handleWrapper,
	__contentWrapper,
	__iconWrapper,
}
